import { t } from '../messages';
export interface DeadlineStatus {
  kind: string;
  at: string | null;
  remainingSeconds: number | null;
  expired: boolean;
  suspended: boolean;
  behavior: string;
}
export function MissionDeadline({ value }: { value?: DeadlineStatus | null }) {
  if (!value) return null;
  return (
    <aside>
      <p>
        {value.kind === 'calendar' && value.at
          ? t('mission.deadline.calendar', {
              at: new Date(value.at).toLocaleString('fr-FR', { timeZone: 'Europe/Paris' }),
            })
          : value.remainingSeconds === null
            ? t('mission.deadline.notStarted')
            : t('mission.deadline.remaining', { seconds: value.remainingSeconds })}
      </p>
      {value.suspended && <p>{t('mission.deadline.suspended')}</p>}
      {value.expired && <p role="status">{t('mission.deadline.expired')}</p>}
      <p>
        {t(
          value.behavior === 'advance'
            ? 'mission.deadline.advanceHelp'
            : 'mission.deadline.waitHelp',
        )}
      </p>
    </aside>
  );
}
